import { SpinResponse } from '@cgs/data-access';
import {
  Compatibility,
  Container,
  debounce,
  RESIZE_HANDLER_TOKEN,
  ResizeHandler,
  ResizeMode,
  SceneObject,
  Vector2,
  viewportChangeListener,
} from '@cgs/wge';
import { ResourcesComponent } from '../../../game/components/resources_component';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { GameStateMachine } from '../../../reels_engine/state_machine/game-state-machine';
import { RESOURCES_COMPONENT_TOKEN } from '../../../type_definitions';

export const BACKGROUND_IMAGE_RESIZE_COMPONENT_TOKEN = Symbol('BackgroundImageResizeComponent');

export class BackgroundImageResizeComponent {
  private readonly resizeHandler: ResizeHandler;
  private readonly backgroundScene: SceneObject;
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;

  constructor(container: Container) {
    this.resizeHandler = container.resolve<ResizeHandler>(RESIZE_HANDLER_TOKEN);
    const resourceComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    this.backgroundScene = resourceComponent.bg;

    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    const debouncedResize = debounce(() => this.resize(), 100);

    viewportChangeListener.on(debouncedResize);

    this.gameStateMachine.init.entered.listen(() => this.resize());
    this.gameStateMachine.beginFreeSpinsPopup.leaved.listen(() => this.resize());
    this.gameStateMachine.endFreeSpinsPopup.leaved.listen(() => this.resize());

    this.resize();
  }

  protected resize(): void {
    if (this.resizeHandler.resizeMode !== ResizeMode.Resize) {
      return;
    }

    if (!Compatibility.IsMobileBrowser) {
      const ratio = window.innerHeight / window.innerWidth;
      const imageRatio = this.backgroundScene.size.x / this.backgroundScene.size.y;

      const backgroundWidthRatio = window.innerWidth / this.backgroundScene.size.x;
      const backgroundHeightRatio = window.innerHeight / this.backgroundScene.size.y;

      let backgroundScale = 1;
      backgroundScale = 1 / (imageRatio * ratio);

      if (backgroundWidthRatio > backgroundHeightRatio) {
        backgroundScale = 1 / (imageRatio * ratio);
      } else {
        backgroundScale = backgroundHeightRatio * ratio;
      }

      this.backgroundScene.scale = new Vector2(backgroundScale, backgroundScale);
      return;
    }
  }
}
